var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 20.5,
    cy: 20.5,
    r: 20.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#AEB9BD",
    stroke: "#AEB9BD",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 27c4.692 0 8.5-3.808 8.5-8.5S25.192 10 20.5 10a8.503 8.503 0 0 0-8.5 8.5c0 4.692 3.808 8.5 8.5 8.5zM35.945 34.56c-.237-.569-.553-1.139-.87-1.668-1.738-2.644-4.465-4.434-7.507-4.882-.395-.04-.79.04-1.107.285a9.097 9.097 0 0 1-5.453 1.83 9.097 9.097 0 0 1-5.453-1.83c-.316-.244-.711-.326-1.106-.285-3.043.448-5.77 2.197-7.508 4.882a9.54 9.54 0 0 0-.87 1.669.795.795 0 0 0 .04.732c.316.529.672 1.099 1.027 1.587a14.122 14.122 0 0 0 1.74 2.034c.552.57 1.145 1.058 1.777 1.546A16.829 16.829 0 0 0 21.008 44c3.754 0 7.35-1.22 10.353-3.54a22.43 22.43 0 0 0 1.778-1.546 14.122 14.122 0 0 0 1.739-2.034 15.4 15.4 0 0 0 1.027-1.587.946.946 0 0 0 .04-.732z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerImagePlaceholder);
export default __webpack_public_path__ + "static/media/customer-image-placeholder.4343029944ce03c6f88b17362099d61a.svg";
export { ForwardRef as ReactComponent };